module.exports = __webpack_public_path__ + "static/media/galpao-estoque.dd93b264.jpg";